import { useAttendeeHubConfig } from '@hooks/useAttendeeHubConfig';
import useTabDefinitions from './useTabDefinitions';
import { usePageDefinitions } from './usePageDefinitions';

export const useNavigationSettings = () => {
  const { loading, isFeatureSettingEnabled } = useAttendeeHubConfig();
  const hasPublicLandingPage = isFeatureSettingEnabled(
    'HAS_PUBLIC_LANDING_PAGE'
  );
  const hasMySchedule = isFeatureSettingEnabled('MY_SCHEDULE');
  const isWebinarNav = isFeatureSettingEnabled('WEBINAR_NAVIGATION');
  const isAttendeeProfileEnabled = isFeatureSettingEnabled('ATTENDEE_PROFILE');

  return {
    hasPublicLandingPage,
    hasMySchedule,
    hasLinks: loading || isWebinarNav ? null : true,
    isAttendeeProfileEnabled,
    isWebinarNav
  };
};

/**
 * Before adding new pages/tabs refer to ./docs/attendeeHubPages.md
 *
 * @returns
 */
const useEventNavigationSettings = () => {
  const {
    hasPublicLandingPage,
    hasMySchedule,
    hasLinks,
    isAttendeeProfileEnabled,
    isWebinarNav
  } = useNavigationSettings();
  const tabs = useTabDefinitions(hasPublicLandingPage);
  const pages = usePageDefinitions({ hasPublicLandingPage, hasLinks });

  return {
    hasPublicLandingPage,
    hasMySchedule,
    hasLinks,
    tabs,
    pages,
    isAttendeeProfileEnabled,
    isWebinarNav
  };
};

export default useEventNavigationSettings;
